import React, { useState, useEffect } from "react"
import store from "../../shared_component/utils/configureStore"
import { Button, Form } from "semantic-ui-react"
import { createCustomersPromotion, loadCustomersPromotions } from "../../v1/actions/promotion"
import Notifications from "../../v1/components/Notifications"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { fetchActiveCart } from "../../v1/actions/user"

const ApplyPromotionV2 = ({ cart, t }) => {
  const [code, setCode] = useState("")

  useEffect(() => {
    fetchPromotions()
  }, [])

  const fetchPromotions = async () => {
    await store.dispatch(loadCustomersPromotions({ cartId: cart.id }))
  }

  const onSubmitCode = async (e) => {
    e.preventDefault()
    if ([null, undefined, ""].includes(code)) return

    await store.dispatch(
      createCustomersPromotion({ code, cartId: cart.id, callback: afterRequest })
    )
  }

  const afterRequest = (status, data) => {
    let baseAttrs = { position: "tr", autoDismiss: 5, action: { label: "Dismiss" } }
    if (status === "success") {
      store.dispatch(
        Notifications.success({
          ...baseAttrs,
          title: t("successTitle"),
          message: t("promotionAppliedMessage")
        })
      )
      store.dispatch(fetchActiveCart())
    } else {
      store.dispatch(
        Notifications.error({
          ...baseAttrs,
          title: t("errorTitle"),
          message: `${data.message || t("errorMessage")}`
        })
      )
    }
  }

  return (
    <div className="promotion-container">
      <div className="promotion-input">
        <Form.Input
          fluid
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder={t("promoCodePlaceholderLabel")}
        />
      </div>
      <div className="promotion-button">
        <Button className="apply-button" onClick={onSubmitCode} content={t("applyLabel")} />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const promotionData = state.promotionData || {}
  return {
    availablePromotions: promotionData.availablePromotions,
    usedPromotions: promotionData.usedPromotions
  }
}

export default connect(mapStateToProps)(
  withTranslation("availablePromotionsContent")(ApplyPromotionV2)
)
